import { useContext } from 'react';
import { CompanyContext } from './companyContext';

const useCompany = () => useContext(CompanyContext);

export default useCompany;
